import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { MapPin } from 'lucide-react';

// Fix default icon issue with Leaflet in React
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

const DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

interface ShopMapProps {
  shopName: string;
  latitude: number;
  longitude: number;
  address?: string;
  className?: string;
}

const ShopMap: React.FC<ShopMapProps> = ({
  shopName,
  latitude,
  longitude,
  address,
  className = ''
}) => {
  return (
    <Card className={`overflow-hidden ${className}`}>
      <CardHeader className="pb-2 py-2 px-3 sm:py-3 sm:px-4">
        <CardTitle className="flex items-center gap-2 text-sm sm:text-base">
          <MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" />
          {shopName} Location
        </CardTitle>
        {address && (
          <p className="text-xs sm:text-sm text-gray-600 mt-1">{address}</p>
        )}
      </CardHeader>
      <CardContent className="p-0">
        <div className="relative w-full h-32 sm:h-48 bg-gray-100">
          <MapContainer
            center={[latitude, longitude]}
            zoom={15}
            style={{ height: '100%', width: '100%' }}
            scrollWheelZoom={false}
          >
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={[latitude, longitude]}>
              <Popup>
                <div className="text-center">
                  <strong>{shopName}</strong>
                  {address && <p className="text-xs mt-1">{address}</p>}
                </div>
              </Popup>
            </Marker>
          </MapContainer>
          <a
            href={`https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`}
            target="_blank"
            rel="noopener noreferrer"
            className="absolute bottom-1 right-1 sm:bottom-2 sm:right-2 bg-white px-1.5 py-0.5 sm:px-2 sm:py-1 rounded shadow text-[10px] sm:text-xs text-blue-600 hover:bg-blue-50 z-[1000]"
          >
            Open in Maps
          </a>
        </div>
      </CardContent>
    </Card>
  );
};

export default ShopMap;